import axios from "../http_v2";

export default {
  list(params) {
    return axios.get("content-service/cnt_article/page_org", params);
  },
  list_org(params) {
    return axios.get("content-service/cnt_article/page_org", params);
  },
  list_all(params) {
    return axios.get("content-service/cnt_article/page_opentenant", params);
  },
  info(id) {
    return axios.get("content-service/cnt_article/" + id);
  },
  add(params) {
    return axios.post("content-service/cnt_article", params);
  },
  update(params) {
    return axios.put("content-service/cnt_article", params);
  },
  del(id) {
    return axios.delete("content-service/cnt_article/" + id, {});
  },
  type: {
    tree(params) {
      return axios.get("content-service/cnt_category/tree", params);
    },
    add(params) {
      return axios.post("content-service/cnt_category", params);
    },
    update(params) {
      return axios.put("content-service/cnt_category", params);
    },
    del(id) {
      return axios.delete("content-service/cnt_category/" + id, {});
    }
  },
  bigName: {
    page: (params) => {
      return axios.post("friendservice/bigName/page", params);
    },
    save: (params) => {
      return axios.post("friendservice/bigNameBlog/save", params);
    },
  },
  topic(params) {
    return axios.get("content-service/cnt_article/page/for/topic", params);
  },
};
